export default function Mission() {
    return (
        <div className="section-padding flex flex-col gap-6 bg-cream">
            <h1 className="text-3xl lg:text-4xl text-slate-800 font-header font-bold">
                Mission
            </h1>
            <p className="text-slate-800 font-body lg:text-lg">
                <b> Arise & Shine Innovation Inc. </b> exists to strengthen mental health, belonging, and resilience
                by cultivating trauma-informed, relational systems that foster <b> COMMUNITY, CONNECTION</b>, and <b> CURIOUSITY </b>
                in schools and communities through intergenerational leadership and trauma-informed learning practices.
            </p>
        </div>
    );
}